import './RecordReferences.scss';

import { AppCountTag, PicklistCountTag, PopulationPercentageTag, ReferenceCountTag, ReportCountTag } from '@ui/tags';
import { RelatedCounts, SonarObjectType } from '@sonar-software/sonar-ts-types';

import { FeatureBoundary } from '@ui/features';
import { FeatureFlag } from '@sonar-software/sonar-core';
import React from 'react';

export interface SonarRecordReferencesProps {
	parentName?: string;
	relatedCounts?: RelatedCounts;
	sonarObjectId: number;
}

export const SonarRecordReferences: React.FC<SonarRecordReferencesProps> = ({
	parentName = '',
	relatedCounts,
	sonarObjectId
}) => {
	if (!relatedCounts) {
		return null;
	}

	return (
		<>
			<ReferenceCountTag count={ relatedCounts.fieldReferencesTotal ?? 0 } />
			<PicklistCountTag count={ relatedCounts[ SonarObjectType.SalesforcePicklistValue ] ?? 0 } />
			<ReportCountTag count={ relatedCounts[ SonarObjectType.SalesforceReport ] ?? 0 } />
			<PopulationPercentageTag
				parentName={ parentName }
				percent={ relatedCounts.populationPercentage } />
			<FeatureBoundary feature={ FeatureFlag.DataSecurityDashboard }>
				{ Boolean(sonarObjectId) && <AppCountTag sonarObjectId={ sonarObjectId } /> }
			</FeatureBoundary>
		</>
	);
};
